import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";

import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockText from "../../Block/BlockText";
import BlockImage from "../../Block/BlockImage";
import Block from "../../Block/Block";
import BlockVideo from "../../Block/BlockVideo";
import BlockButton from "../../Block/BlockButton";

function PointCloudLabelingTool() {
    return (
        <div>
            <Header/>        

            <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                        height:"200px",
                        width: "100%",
                        backgroundSize: "100% 100%",
                        backgroundPosition: "bottom"}}>
            </div>

            <Block colorTheme="light" gridTemplateColumns="600px 600px">
                <BlockContent>
                <BlockTitle>Point Cloud Labeling Tool</BlockTitle>
                </BlockContent>
                <BlockContent>
                <BlockText>This tool enables interactive and user-friendly annotation of 3D point clouds in PLY format. It is provided as a web-based application.</BlockText>
                </BlockContent>
            </Block>

            <Block gridTemplateColumns="600px 600px">
                <BlockContent>
                <BlockText>
                    This tool provides an intuitive way to annotate individual objects within 3D point clouds, for example in room reconstructions captured with large-scale LiDAR scanners. A primary application is the creation of labeled datasets for machine learning tasks, particularly semantic scene understanding. The annotation workflow is straightforward: users define 3D bounding boxes that can be translated and scaled in the main view, or translated, scaled, and rotated in three orthogonal views for precise placement. A demonstration of the application is shown in Video 1.
                </BlockText>
                </BlockContent>
                <BlockContent>
                    <BlockImage src={process.env.PUBLIC_URL + '/images/project_cards/3DLabelingTool.webp'} title="Figure 1: Interface of the labeling tool, showing its four views for interactive annotation."/>
                </BlockContent>
            </Block>

            <Block gridTemplateColumns="1200px">
                <BlockContent>
                    <BlockVideo src="https://potechius.com/Videos/LabelingTool.mp4" title="Video 1: Demonstration of the point cloud labeling tool. The model in this demo was created by HagaeusBygghantverk and can be downloaded <a href='https://sketchfab.com/3d-models/tottieska-malmgarden-faro-pointcloud-decimated-49b2fffdda8944b3a0871a05e4c8e14d'>here</a>."/>
                </BlockContent>
            </Block>

            {/* <Block colorTheme="light" gridTemplateColumns="1200px"> 
                <BlockContent textAlign="center" color="grey" fontStyle="italic">
                <BlockButton width="190px" onClick={() => window.open("http://signal.potechius.com:9124/")}>Demo</BlockButton>
                </BlockContent>
            </Block> */}

            <Footer/>
        </div>
    );
}

export default PointCloudLabelingTool;